import { render, staticRenderFns } from "./SiteNavDesktopV2AboutNav.vue?vue&type=template&id=6b3178b6&scoped=true&lang=pug"
import script from "./SiteNavDesktopV2AboutNav.vue?vue&type=script&lang=js"
export * from "./SiteNavDesktopV2AboutNav.vue?vue&type=script&lang=js"
import style0 from "./SiteNavDesktopV2AboutNav.vue?vue&type=style&index=0&id=6b3178b6&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3178b6",
  null
  
)

export default component.exports